import { ErrorType } from 'data/App/types'

import {
  FETCH_NEXT_TRANSACTIONS_PAGE,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_ERROR,
  FETCH_TRANSACTIONS_SUCCESS
} from './actionTypes'
import { TransactionsResponse, TransactionType } from './types'

type FetchTransactionsAction = {
  payload: { type: TransactionType }
  type: typeof FETCH_TRANSACTIONS
}
export const fetch = (type: TransactionType): FetchTransactionsAction => ({
  payload: { type },
  type: FETCH_TRANSACTIONS
})

type FetchTransactionsSuccessAction = {
  payload: { transactions: TransactionsResponse; type: TransactionType }
  type: typeof FETCH_TRANSACTIONS_SUCCESS
}
export const fetchSuccess = (
  type: TransactionType,
  transactions: TransactionsResponse
): FetchTransactionsSuccessAction => ({
  payload: { transactions, type },
  type: FETCH_TRANSACTIONS_SUCCESS
})

type FetchTransactionsActionError = {
  payload: { error: ErrorType; type: TransactionType }
  type: typeof FETCH_TRANSACTIONS_ERROR
}
export const fetchError = (
  type: TransactionType,
  error: ErrorType
): FetchTransactionsActionError => ({
  payload: { error, type },
  type: FETCH_TRANSACTIONS_ERROR
})

type FetchNextTransactionsPageAction = {
  payload: { type: TransactionType }
  type: typeof FETCH_NEXT_TRANSACTIONS_PAGE
}
export const fetchNextPage = (type: TransactionType): FetchNextTransactionsPageAction => ({
  payload: { type },
  type: FETCH_NEXT_TRANSACTIONS_PAGE
})

export type TransactionsActions =
  | FetchTransactionsAction
  | FetchTransactionsSuccessAction
  | FetchTransactionsActionError
  | FetchNextTransactionsPageAction
